var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal-container" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h2", [_vm._v("Next Steps..")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c(
              "form",
              {
                staticClass: "2fa-form",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                  }
                }
              },
              [
                _c("div", { staticClass: "login-content resetpage-content" }, [
                  _c(
                    "ul",
                    { staticClass: "nextsteps" },
                    _vm._l(_vm.nextsteps[_vm.selectedapp], function(step) {
                      return _c("li", [_c("b", [_vm._v(_vm._s(step))])])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-element form-button" }, [
                    _c(
                      "button",
                      {
                        staticClass: "w3-btn signin-btn",
                        attrs: { type: "submit" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("close")
                          }
                        }
                      },
                      [_vm._v("Close")]
                    )
                  ])
                ])
              ]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-footer" })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }